
  <img src="../../../../../assets/icons/custom/no-data-found.png" />
  <div style="font-weight: 600; font-size: 20px; color: #424f77;">{{'NoResultFound' | translate}}</div>
  <div style=" font-size: 12px; color: #424f77; font-weight: 500;width:150px;margin:0 auto">{{'NoResultFoundSubText' | translate}}</div>

